export default __webpack_public_path__ + "static/media/G0860.Breech_08-SemiR-head_delay2.1695378600000.bd485333.jpg";